<!-- <div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto"> -->
@if(!_orderWizardService.loading$()) {
    @if(!_orderWizardService.getValue(x=>x.step03?.customerDto?.isMailConfirmed) || _orderWizardService.orderWizard$()?.step03?.customerDto?.isAskMailConfirmed) {
        <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
    }
}
@else {
    <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
}
    <!-- </div>
</div> -->

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>
    <div class="max-w-4xl bg-white dark:bg-gray-900 rounded-tr-lg rounded-br-lg rounded-bl-lg shadow p-6 space-y-4">
                <div class="flex items-center">
                    <span class="material-symbols-outlined text-danger-400 text-xl">
                        unsubscribe
                    </span>

                    <div class="ltr:ml-[12px] rtl:mr-[12px]">
                        <span class="block text-md mb-[2px] font-medium text-black dark:text-white text-lg font-semibold text-blue-900">
                            <!-- i18n: Email address not verified -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.span_01' | translate }} 
                           
                        </span>
                    </div>
                </div>

                <!-- Description -->
                <p class="text-sm text-blue-700 mt-2">
                     <!-- i18n: To continue, please confirm your email address. -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.p_01' | translate }} 
                </p>

                <!-- Email affiché -->
                @if(!_orderWizardService.loading$()) {
                    <form [formGroup]="form!" >
                        <div class="mt-3 text-sm text-blue-800 font-medium"><ng-container *ngTemplateOutlet="tp_email"></ng-container></div>
                        <ng-template #tp_email>
                            <div [formGroupName]="_orderWizardService.modelNames.step03.key">
                                <div [formGroupName]="_orderWizardService.modelNames.step03.fields.customerDto.key">
                                    <corp-input 
                                        [corp-loading]="_orderWizardService.loadingEmailValidation$()"
                                        [formControlName]="_orderWizardService.modelNames.step03.fields.customerDto.fields.email.key">
                                    </corp-input>
                                </div>
                            </div>
                        </ng-template>
                    </form>
                }

                @if(_orderWizardService.loadingEmailValidation$()) {
                    @if(_orderWizardService.emailValidationIsSent$()) {
                        <div class="grid grid-cols-[20px_1fr] gap-x-2 items-center text-sm text-secondary-500 pt-5">
                            <span class="material-symbols-outlined text-green-500 text-base leading-none block">
                                check_circle
                            </span>
                            <span>
                                
                                <!-- i18n: Email sent! Please check your email. -->
                                {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.span_02' | translate }} 
                            </span>

                            <div></div>
                            <span>
                                <!-- i18n: Remember to check your spam folder if you don't receive anything. -->
                                {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.span_03' | translate }} 
                            </span>
   
                            <div class="col-span-2 h-5"></div>

                            <span class="material-symbols-outlined text-green-500 text-base leading-none block ">
                                hourglass_bottom
                            </span>
                            <span>
                                <!-- i18n: Awaiting email validation… -->
                                {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.span_04' | translate }}  
                            </span>
                            <div></div>
                            <span>
                                <!-- i18n: Time remaining: -->
                                {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.span_05' | translate }} 
                                {{ _orderWizardService.emailValidationPoolingCountdown$() | msToTime }}
                            </span>
                        </div>
                    }
                }

                <button
                    [disabled]="_orderWizardService.loadingEmailValidation$()"
                    class="mt-5 w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-5 py-2 rounded-lg transition disabled:cursor-not-allowed disabled:opacity-50"
                    (click)="sendValidation()">
                    <!-- i18n: Send the verification email -->
                    {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.button_01' | translate }} 
                </button>

    </div>
</ng-template>

<!-- Abandon de la transaction -->
<corp-modal 
    [active]="_orderWizardService.emailValidationIsTimeOut$()" 
    [title]="'i18n.app.features.pages.order.wizard.step_03.email-validation.corp_modal_title_01' | translate">
    <div class="trezo-card-content pb-[20px] md:pb-[25px]">
        <!-- i18n - The time limit for verifying your email has expired. -->
        {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.div_01' | translate }}
        <br>
        <!-- i18n - Your transaction has been cancelled.-->
        {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.div_02' | translate }}
    </div>
    <div class="trezo-card-footer flex items-center justify-between -mx-[20px] md:-mx-[25px] px-[20px] md:px-[25px] pt-[20px] md:pt-[25px] border-t border-gray-100 dark:border-[#172036]">
         <button 
            class="inline-block py-[5px] px-[30px] bg-primary-500 text-white transition-all hover:bg-primary-400 rounded-md border border-primary-500 hover:border-primary-400 ltr:mr-[11px] rtl:ml-[11px]" 
            type="button"
            (click)="goHome()"
        >
            <!-- i18n - Ok-->
            {{ 'i18n.app.features.pages.order.wizard.step_03.email-validation.button_02' | translate }}
        </button>
    </div>
</corp-modal>
